import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import { CanGoOutAloneConditionsCreatePage } from './can-go-out-alone-condition-create'
import { CanGoOutAloneConditionsListPage } from './can-go-out-alone-condition-list'
import { CanGoOutAloneConditionsUpdatePage } from './can-go-out-alone-condition-update'

export const canGoOutAloneConditionsRoutes: Route[] = [
  {
    path: Paths.CAN_GO_OUT_ALONE_CONDITION_LIST_PAGE,
    element: <CanGoOutAloneConditionsListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.CAN_GO_OUT_ALONE_CONDITION_CREATE_PAGE,
    element: <CanGoOutAloneConditionsCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.CAN_GO_OUT_ALONE_CONDITION_UPDATE_PAGE,
    element: <CanGoOutAloneConditionsUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]
